module.exports = __webpack_public_path__ + "img/organization-info-icon.44b955be.svg";